import { VStack, Text, StackProps } from '@chakra-ui/react';

import { format, getDay } from 'date-fns';

import { weekLabel } from '~/types/utilities';

type StoreLastPreOrderTimeNoticeProps = {
  isValidTime: boolean;
  time: Date;
  isEnterpriseGroupBuy?: boolean;
} & StackProps;

export default function StoreLastPreOrderTimeNotice({
  isValidTime,
  time,
  isEnterpriseGroupBuy = false,
  ...props
}: StoreLastPreOrderTimeNoticeProps) {
  if (isValidTime) {
    return (
      <VStack align="stretch" bgColor="gray.200" px={2} py={4} borderRadius="5px" {...props}>
        <Text fontSize="xs" fontWeight="bold">
          請在
          {` ${format(time, 'MM/dd')}(${weekLabel[getDay(time)].label}) ${format(time, 'HH:mm')} `}
          前完成結帳
        </Text>
        {!isEnterpriseGroupBuy ? (
          <Text fontSize="xs">超過店家在該取餐時間最後可接受預約的時間將無法下單</Text>
        ) : null}
      </VStack>
    );
  }
  return (
    <VStack align="stretch" bgColor="danger.200" px={2} py={4} borderRadius="5px" {...props}>
      <Text color="danger.600" fontSize="xs" fontWeight="bold">
        該店家已過結單時間
      </Text>
      <Text color="danger.600" fontSize="xs">
        您所選取的取餐時間已過店家結單時間
      </Text>
    </VStack>
  );
}
